import React, { Component } from 'react';
import { connect } from 'react-redux';
import Assets from './Assets';
import Transfers from './Transfers';
import History from './History';
import './passport.css';
import Start from './Upload';

class Home extends Component {
  render() {
    if(this.props.loggedIn != undefined){
      return (
        <div className='passportTop'>
          <div id='passport' className='minWidth container row passportDiv'>
            <Assets/>
            <div className='col s9' style={{padding:0}}>
              <Transfers/>
              <History/>
            </div>
          </div>
        </div>
      );
    }
    else return (<Start/>);
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.passport.wallet.emb && state.passport.wallet.nrg && state.passport.wallet['l-emb']
  }
}

export default connect(mapStateToProps,{})(Home);
